// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qg_a bhe_su bhe_kv bhe_kw","PostDetailRight__brandDaysPosts":"qg_b bhe_su bhe_kv bhe_kw"};